export default [
  //Trang thiết lập
  {
    path: "setting",
    name: "setting",
    component: () => import("@/views/setting/SettingViews.vue"),
    children: [
      // Submenu thiết lập chung
      {
        path: "general-setting",
        name: "general-setting",
        isPermission: true,
        component: () => import("@/views/setting/general_setting/GeneralSetting.vue"),
      },
      // Danh sách phòng ban
      {
        path: "department-list",
        name: "department-list",
        subsystemCode: "DepartmentList",
        component: () => import("@/views/setting/department/DepartmentList.vue"),
      },
      // Người dùng - vai trò
      {
        path: "user-role",
        name: "user-role",
        redirect: { name: "user" },
        component: () => import("@/views/setting/user-role/UserRole.vue"),
        meta: {},
        subsystemCode: "UserRole",
        children: [
          // Tab nguoi dung
          {
            path: "user",
            name: "user",
            subsystemCode: "UserRole",
            default: true,
            component: () => import("@/views/setting/user-role/SettingUser.vue"),
          },
          // Tab thông tin vai tro app
          {
            path: "role",
            name: "role",
            subsystemCode: "UserRole",
            component: () => import("@/views/setting/user-role/SettingRole.vue"),
          }]
      },
      // Danh sách người dùng
      {
        path: "user-list",
        name: "user-list",
        subsystemCode: "UserList",
        component: () => import("@/views/setting/UserList.vue"),
      },
      // Lịch sử thỏa thuận
      // {
      //   path: "license-list",
      //   name: "license-list",
      //   isPermission: true,
      //   component: () => import("@/views/setting/license/AgreementLicenseList.vue"),
      // },
      //SubMenu Bàn giao công việc
      {
        path: "handover",
        name: "handover",
        isPermission: true,
        component: () => import("@/views/setting/handover/Handover.vue"),
      },
      //SubMenu Thiết lập cá nhân
      {
        path: "personal-setting",
        name: "personal-setting",
        redirect: { name: "authorization" },
        subsystemCode: "ConfigPersonal",
        component: () => import("@/views/setting/personal_setting/PersonalSetting.vue"),
        children: [ //Submenu ủy quyền
          {
            path: "authorization",
            name: "authorization",
            subsystemCode: "ConfigPersonal",
            component: () => import("@/views/setting/personal_setting/authorization/Authorization.vue"),
          },
          //Submenu Nhóm giao việc
          {
            path: "assignment",
            name: "assignment",
            subsystemCode: "ConfigPersonal",
            redirect: { name: 'assignment-group' },
            component: () => import("@/views/setting/personal_setting/assignment/AssignmentGroupView.vue"),
            children: [
              {
                path: "group",
                name: "assignment-group",
                component: () => import("@/views/setting/personal_setting/assignment/AssignmentGroup.vue"),
              },
              {
                path: "member/:groupID",
                name: "assignment-member",
                component: () => import("@/views/setting/personal_setting/assignment/MemberAssignmentGroup.vue"),
              }
            ],
          },]
      }
    ]
  }
]